import { Box, styled, TableContainer, Text } from '@ltvco/refresh-lib/theme';

import { MonthlyUsageTable } from './components';

function formatMonthLabel(monthIso: string) {
  const d = new Date(`${monthIso}T12:00:00`);
  if (Number.isNaN(d.getTime())) {
    return monthIso;
  }
  return d.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
}

const MonthlyUsageSummaryTable = styled(MonthlyUsageTable)(({ theme }) => ({
  '& .MuiTableCell-head': {
    backgroundColor: theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.divider}`,
    ...theme.typography.body2,
    fontWeight: 600,
  },
  '& .MuiTableCell-body': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

function monthlyUsageTableRows(
  monthlySorted: Array<{ month: string; creditsUsed: number }>
) {
  if (monthlySorted.length === 0) {
    return [
      [
        <Text key="empty" variant="body2">
          No monthly usage yet.
        </Text>,
        '',
      ],
    ];
  }
  return monthlySorted.map((row) => [
    formatMonthLabel(row.month),
    `${row.creditsUsed} Credits`,
  ]);
}

export function MonthlyUsageTabPanel({
  isLoading,
  monthlySorted,
}: {
  isLoading: boolean;
  monthlySorted: Array<{ month: string; creditsUsed: number }>;
}) {
  return (
    <Box sx={{ mt: 2 }}>
      <Text variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Successful API calls by calendar month (last 12 months). Credits reflect
        completed transactions only.
      </Text>

      {isLoading ? (
        <Text>Loading...</Text>
      ) : (
        <TableContainer
          sx={(theme) => ({
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: theme.spacing(1),
            overflow: 'hidden',
          })}
        >
          <MonthlyUsageSummaryTable
            size="small"
            headers={['Month', 'Credits used (successful calls)']}
            rows={monthlyUsageTableRows(monthlySorted)}
          />
        </TableContainer>
      )}
    </Box>
  );
}
